import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/gestionale/integrations/supabase/client";
import type { Tables } from "@/gestionale/integrations/supabase/types";

type Sponsor = Tables<"sponsors">;

export default function SponsorStripGestionale() {
  const { data: sponsors = [] } = useQuery({
    queryKey: ["sponsors-strip-gestionale"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("sponsors")
        .select("*")
        .eq("active", true)
        .order("sort_order", { ascending: true });
      if (error) throw error;
      return data as Sponsor[];
    },
  });

  if (sponsors.length === 0) return null;

  const renderLogo = (s: Sponsor, keyPrefix: string) => (
    <a
      key={`${keyPrefix}-${s.id}`}
      href={s.website_url || undefined}
      target={s.website_url ? "_blank" : undefined}
      rel="noopener noreferrer"
      title={s.name}
      className="shrink-0 mx-6 flex items-center transition-transform duration-200 hover:scale-110"
    >
      {s.logo_url ? (
        <img
          src={s.logo_url}
          alt={s.name}
          className="h-8 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
        />
      ) : (
        <span className="text-sm font-medium text-muted-foreground hover:text-primary transition-colors whitespace-nowrap">
          {s.name}
        </span>
      )}
    </a>
  );

  return (
    <div className="w-full bg-card/50 border-b border-border/50 py-1.5 overflow-hidden group">
      <div className="flex w-max animate-sponsor-scroll group-hover:[animation-play-state:paused]">
        {sponsors.map((s) => renderLogo(s, "a"))}
        {sponsors.map((s) => renderLogo(s, "b"))}
      </div>
    </div>
  );
}